"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const TablePagination = _ref => {
  let {
    table
  } = _ref;
  const getPaginationControl = (goToPage, className) => {
    if (className === 'pagination-previous') {
      return '<';
    }
    if (className === 'pagination-next') {
      return '>';
    }
    return goToPage;
  };
  const generateLi = (goToPage, className) => /*#__PURE__*/_react.default.createElement("li", {
    key: goToPage + className
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: `${goToPage}`,
    className: className,
    "aria-label": `Goto page ${goToPage}`,
    onClick: e => {
      e.preventDefault();
      table.setPageIndex(goToPage - 1);
    }
  }, getPaginationControl(goToPage, className)));
  const page = table.getState().pagination.pageIndex;
  const totalPages = table.getPageCount();
  const canNext = table.getCanNextPage();
  const canPrevious = table.getCanPreviousPage();
  let middlePages = [];
  const currentPage = page + 1;
  if (totalPages <= 1) return null;
  if (totalPages === 2) middlePages = [];else if (totalPages === 3) middlePages = [2];else if (totalPages === 4) middlePages = [2, 3];else if (totalPages === 5) middlePages = [2, 3, 4];else if (currentPage < 5) middlePages = [2, 3, 4];else if (currentPage > totalPages - 4) middlePages = [totalPages - 3, totalPages - 2, totalPages - 1];else middlePages = [currentPage - 1, currentPage, currentPage + 1];
  return /*#__PURE__*/_react.default.createElement("nav", {
    className: "pagination is-normal is-centered is-marginless",
    role: "navigation",
    "aria-label": "pagination"
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: "pagination-list"
  }, canPrevious ? generateLi(currentPage - 1, 'pagination-previous') : null, generateLi(1, currentPage === 1 ? 'pagination-link is-current' : 'pagination-link'), currentPage > 4 ? /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("span", {
    className: "pagination-ellipsis"
  }, "\u2026")) : null, middlePages.map(mp => generateLi(mp, mp === currentPage ? 'pagination-link is-current' : 'pagination-link')), currentPage < totalPages - 3 ? /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("span", {
    className: "pagination-ellipsis"
  }, "\u2026")) : null, generateLi(totalPages, currentPage === totalPages ? 'pagination-link is-current' : 'pagination-link'), canNext ? generateLi(currentPage + 1, 'pagination-next') : null));
};
TablePagination.propTypes = {
  table: _propTypes.default.shape({
    getPageIndex: _propTypes.default.func,
    getState: _propTypes.default.func,
    setPageIndex: _propTypes.default.func,
    getPageCount: _propTypes.default.func,
    getCanNextPage: _propTypes.default.func,
    getCanPreviousPage: _propTypes.default.func
  })
};
TablePagination.defaultProps = {
  tableIdentifer: 'default'
};
var _default = exports.default = TablePagination;
//# sourceMappingURL=TablePagination.js.map